$(window).on('DOMContentLoaded', function () {

    const wrapper = document.querySelector('body');
    let code = '';
    let state = '';

    function randomString(i) {
        let rnd = '';
        while (rnd.length < i)
            rnd += Math.random().toString(36).substring(2);
        return rnd.substring(0, i);
    };

    function saveState(state) {
        const expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 1);
        document.cookie = `stateData=${state}; expires=${expirationDate.toUTCString()}; path=/`;
        console.log(document.cookie);
    }

    function getState() {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith('stateData=')) {
                return cookie.substring('stateData='.length, cookie.length);
            }
        }
        return null;
    }

    function saveToken(token) {
        const expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 1);
        document.cookie = `tokenData=${token}; expires=${expirationDate.toUTCString()}; path=/`;
    }

    function getTokenData(type) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/ajax/getAccessToken.php',
                method: 'GET',
                data: {
                    code: code,
                    state: state,
                    type: type
                },
                success: function (response) {
                    if(!response) {
                        response = `{
                            "error": "Redirect URI mismatch"
                        }`;
                    }
                    const parsedResponse = JSON.parse(response);
                    saveToken(parsedResponse.refresh_token);
                    resolve(parsedResponse.access_token);
                },
                error: function (xhr, status, error) {
                    console.error(error);
                    reject(error);
                }
            });
        });
    }

    function getUserInfo(access_token, type) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/ajax/getUserInfo.php',
                method: 'GET',
                data: {
                    access_token: access_token,
                    type: type,
                },
                success: function (response) {
                    resolve(response);
                },
                error: function (xhr, status, error) {
                    reject(error);
                }
            });
        });
    }

    function authUser(data) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/ajax/auth.php',
                method: 'GET',
                data: {
                    data: data,
                },
                success: function (response) {
                    resolve(response);
                },
                error: function (xhr, status, error) {
                    console.log(error);
                    reject(error);
                }
            });
        });
    }

    async function getResult(type = '') {
        try {
            const token = await getTokenData(type);
            const userinfo = await getUserInfo(token, type);
            const result = await authUser(userinfo);
            return result;
        } catch (error) {
            throw error;
        }
    }

    function generateState() {
        const state = randomString(12);
        saveState(state);

        return state;
    };

    function setOverlay() {
        let overlay;
        overlay = $('<div id="fade-wrapper" onclick="$(this).remove();"></div>');
        $(wrapper).append(overlay);
        return overlay;
    }

    function openWindow(host, client_id = '', url_redirect = '', state = '', options = {}) {
        const queryParams = new URLSearchParams({
            response_type: "code",
            client_id: client_id ? client_id : undefined,
            redirect_uri: url_redirect ? url_redirect : undefined,
            state: state ? state : undefined,
            ...options
        });
    
        queryParams.forEach((value, key) => {
            if (value === undefined || value === null || value === '') {
                queryParams.delete(key);
            }
        });
    
        return window.open(
            `${host}?${queryParams.toString()}`
        );
    }

    function isClickable(element) {
        return (
            element.tagName === "BUTTON" ||
            element.tagName === "A" ||
            element.tagName === "INPUT" ||
            element.closest('a')
        );
    }

    ;(function fetchWithAuth() {
        let overlay;

        document.addEventListener('click', (e) => {
            let authWindow;

            if (e.target.classList.contains('auth-btn')) {
                e.preventDefault();

                state = generateState();
                overlay = setOverlay();

                authWindow = openWindow(
                    window.env.STADA_API_AUTH,
                    window.env.STADA_CLIENT_ID,
                    window.env.STADA_API_REDIRECT,
                    state,
                    {
                        action: e.target.dataset.type
                    }
                );
            }

            const checkClosedInterval = setInterval(function() {
                if (typeof authWindow !== 'undefined' && authWindow.closed) {
                    clearInterval(checkClosedInterval);
                    overlay.remove();
                    window.location.reload();
                }
            }, 100);
        })

        if (typeof URLSearchParams !== 'undefined') {
            const params = new URLSearchParams(window.location.search);

            if ((code = params.get('code')) && (state = params.get('state'))) {
                const type = params.get('simple');

                if ((getState() === state)) {
                    const preloader = $('<div id="preloader"><img src="/img/authorization/preloader.gif" /></div>');

                    $(wrapper).append(preloader);

                    getResult(type).then(function (result) {
                        if (result) {
                            window.close();
                        }
                    })
                }
            }
        }
    }(window));
})